import { render, staticRenderFns } from "./AppointmentDetails.vue?vue&type=template&id=4ff0ed7b&scoped=true"
import script from "./AppointmentDetails.vue?vue&type=script&lang=js"
export * from "./AppointmentDetails.vue?vue&type=script&lang=js"
import style0 from "./AppointmentDetails.vue?vue&type=style&index=0&id=4ff0ed7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff0ed7b",
  null
  
)

export default component.exports